module.exports = __webpack_public_path__ + "static/media/logo17.e6733584.png";